import React, { useState } from "react";

import Tooltip from "@mui/material/Tooltip";
import InfoIcon from "@mui/icons-material/Info";
import { IconButton, Typography, styled } from "@mui/material";

import InfoDialog from "../modals/InfoDialog";

const StyledTooltipText = styled('span')({
  fontSize: "14px",
  lineHeight: "18px",
})

const LayerInfo = ({
  shortDescription,
  longDescription,
  longDescriptionTitle,
}) => {
  const [longDescriptionOpen, setLongDescriptionOpen] = useState(false);
  const [tooltipOpen, setTooltipOpen] = useState(false);

  if (!shortDescription && !longDescription) {
    return null;
  }

  const renderTooltipTitle = () => {
    let text = "Click here to read more."

    if (longDescription && shortDescription) {
      text = `${shortDescription} Click here to read more.`
    } else if (shortDescription) {
      text = shortDescription 
    }

    return (<StyledTooltipText>{text}</StyledTooltipText>)
  }

  const renderIconButton = () => {
    if (!longDescription) {
      return (
        <InfoIcon
          sx={{ pl: 1 }}
          onClick={() => setTooltipOpen(!tooltipOpen)} />
      )
    }

    return (
      <IconButton onClick={() => setLongDescriptionOpen(true)}>
        <InfoIcon />
      </IconButton>
    )
  }

  const renderInfoDialog = () => {
    if (!longDescription) {
      return undefined
    }

    return (
      <InfoDialog
        open={longDescriptionOpen}
        setOpen={setLongDescriptionOpen}
        DialogTitle={renderDialogTitle}
        DialogBody={renderDialogBody}
        showCiuLogo={false}
        showTour={false} />
    )
  }

  const renderDialogTitle = () => {
    if (!longDescription) {
      return undefined
    }
    return (<span>{longDescriptionTitle}</span>)
  }

  const renderDialogBody = () => {
    let paragraphs = longDescription
    if (!Array.isArray(longDescription)) {
      paragraphs = [paragraphs]
    }

    const renderParagraph = (content, key) => {
      return (
        <Typography variant="body1" paragraph key={key}>
          {content}
        </Typography>
      )
    }

    return (
      <>{paragraphs.map((para, i) => renderParagraph(para, i))}</>
    )
  }

  return (
    <>
      <Tooltip
        open={tooltipOpen}
        onOpen={() => setTooltipOpen(true)}
        onClose={() => setTooltipOpen(false)}
        leaveTouchDelay={4000}
        title={renderTooltipTitle()}
        placement="top">
        {renderIconButton()}
      </Tooltip>
      {renderInfoDialog()}
    </>
  );
};

export default LayerInfo;
